const config = {
  api: {
    // url: "http://localhost:1337/api/",
    // mediaUrl: "http://localhost:1337",
    url: "https://api.studio-sam.fr/api/",
    mediaUrl: "https://api.studio-sam.fr",
    // token: "7a5ebc8fdac4fabf4c0cc7bbfa8829923c6879d550442d9dbdcf731bfcf3c594d94e8a9ebcfaf0bc73e1b3cecf915ae5259499ca3e1468aa653c371aeba35ac953fc6fa69765401b3294c001466667db31d0c8817fcf9b025646077d105c7b7a6dcba0b3222c50264eb16f352cc48f1b2c4307b76eb0131ea4da5f236e9977d1",
    token:
      process.env.REACT_APP_API_SAM_TOKEN,
  },
};

export const Config =  config;